import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path d="M23.46,14.53c-0.94-0.32-1.87-0.69-2.81-1c-0.38-0.13-0.57-0.35-0.71-0.72c-0.19-0.52-0.47-1.01-0.72-1.53
		c1-0.53,2-1.06,3.02-1.6c-0.7-1.21-1.38-2.4-2.07-3.59c-0.11,0.07-0.2,0.12-0.3,0.18c-1.12,0.71-2.25,1.42-3.37,2.14
		c-0.15,0.1-0.27,0.1-0.44,0.02c-0.62-0.27-1.24-0.52-1.88-0.74c-0.18-0.06-0.24-0.13-0.23-0.31c0.04-0.66,0.07-1.33,0.08-1.99
		c0.01-0.59,0-1.18,0-1.77c-1.34,0-2.7,0-4.07,0c0.05,1.26,0.1,2.49,0.15,3.72c0.01,0.21-0.04,0.3-0.26,0.38
		C9.25,7.91,8.64,8.17,8.03,8.43C7.87,8.5,7.77,8.5,7.62,8.41c-0.86-0.56-1.73-1.1-2.6-1.65C4.66,6.53,4.31,6.31,3.94,6.08
		c-0.69,1.21-1.38,2.39-2.07,3.6c1.03,0.55,2.04,1.08,3.06,1.63c-0.62,0.98-1.01,2-1.23,3.15c-1.09-0.48-2.14-0.95-3.23-1.43
		c0,1.87,0,3.66,0.01,5.46c0,0.08,0.09,0.2,0.16,0.23c0.56,0.25,1.13,0.47,1.7,0.71c2.04,0.86,4.16,0.97,6.32,0.65
		c1.1-0.16,2.1-0.63,3.1-1.08c2.66-1.19,5.36-1.3,8.08-0.26c0.8,0.3,1.56,0.71,2.35,1.03c0.45,0.18,0.93,0.27,1.45,0.42
		c0-0.37,0-0.66,0-0.95c0-1.46,0-2.92,0-4.38C23.64,14.71,23.65,14.6,23.46,14.53z M23.17,19.61c-0.53-0.2-1.03-0.36-1.5-0.58
		c-1.14-0.53-2.27-1.1-3.53-1.31c-0.01,0-0.01,0-0.02-0.01c0,0-0.01-0.01-0.01-0.01c0,0,0,0-0.01,0c-0.01-0.01-0.02-0.01-0.03-0.02
		c0,0,0,0,0,0h0l0,0c-0.32-0.02-0.63-0.04-0.95-0.06c-0.32-0.02-0.63-0.04-0.95-0.04c-1.63-0.03-3.18,0.29-4.66,1
		c-1.07,0.52-2.17,0.97-3.37,1.09c-1.95,0.2-3.87,0.08-5.69-0.72c-0.43-0.19-0.87-0.36-1.3-0.56c-0.08-0.04-0.19-0.14-0.19-0.22
		c-0.01-1.46-0.01-2.92-0.01-4.42c0.23,0.1,0.43,0.19,0.63,0.28c1.14,0.57,2.31,1.05,3.59,1.2c2.14,0.24,4.2,0.04,6.17-0.9
		c1.03-0.49,2.07-0.94,3.22-1.08c2.01-0.24,3.98-0.13,5.87,0.7c0.42,0.18,0.85,0.36,1.34,0.57c-0.16,0.02-0.25,0.03-0.35,0.05
		c0,0.37,0,0.72,0,1.12c0.43-0.22,0.61-0.59,0.77-1c0.3,0.09,0.59,0.16,0.87,0.26c0.05,0.02,0.1,0.1,0.1,0.15
		C23.17,16.58,23.17,18.06,23.17,19.61z"/>
	<path d="M18.07,17.68c0-1.03,0-2.07,0-3.13c0.41,0,0.78-0.01,1.15,0.01c0.09,0.01,0.2,0.12,0.24,0.21
		c0.33,0.72,0.64,1.45,0.95,2.15c0-0.77,0-1.55,0-2.36c0.24,0,0.47,0,0.74,0c0,1.02,0,2.04,0,3.1c-0.38,0-0.76,0.01-1.14-0.01
		c-0.08,0-0.17-0.12-0.21-0.21c-0.33-0.72-0.64-1.45-0.95-2.16c0,0.76,0,1.54,0,2.38C18.59,17.68,18.33,17.68,18.07,17.68
		C18.06,17.68,18.07,17.68,18.07,17.68z"/>
	<path d="M4.62,18.29c-0.81,0.3-1.2-0.11-1.42-0.79c-0.08-0.24-0.23-0.37-0.53-0.25c0,0.35,0,0.71,0,1.08c-0.3,0-0.56,0-0.85,0
		c0-1.02,0-2.04,0-3.13c0.63,0.03,1.25,0.04,1.86,0.11c0.39,0.05,0.7,0.28,0.76,0.71c0.06,0.46-0.15,0.77-0.6,0.97
		C4.1,17.43,4.36,17.87,4.62,18.29z M2.69,15.76c0,0.31,0,0.6,0,0.9c0.3,0,0.62,0.1,0.79-0.2c0.07-0.13,0.07-0.37-0.01-0.5
		C3.29,15.67,2.98,15.75,2.69,15.76z"/>
	<path d="M12.8,15.65c-0.37,0.06-0.63,0.11-0.91,0.16c-0.03-0.07-0.05-0.14-0.08-0.21c-0.09-0.27-0.3-0.39-0.56-0.33
		c-0.12,0.02-0.27,0.13-0.3,0.23c-0.02,0.1,0.07,0.28,0.16,0.33c0.19,0.11,0.41,0.16,0.62,0.23c0.22,0.08,0.45,0.14,0.65,0.25
		c0.59,0.32,0.62,1.1,0.03,1.41c-0.66,0.36-1.36,0.33-2.03-0.01c-0.27-0.14-0.41-0.4-0.46-0.73c0.3-0.03,0.58-0.06,0.86-0.09
		c0.25,0.46,0.47,0.61,0.83,0.51c0.11-0.03,0.26-0.14,0.27-0.22c0.01-0.11-0.09-0.27-0.19-0.32c-0.21-0.11-0.45-0.16-0.68-0.25
		c-0.2-0.08-0.42-0.15-0.6-0.27c-0.46-0.31-0.48-0.94-0.05-1.29c0.48-0.39,1.56-0.39,2.02,0.02C12.54,15.2,12.64,15.42,12.8,15.65z"
		/>
	<path d="M15.02,13.59c0.3,0,0.57,0,0.87,0c0,1.02,0,2.03,0,3.07c-0.28,0-0.57,0-0.87,0C15.02,15.64,15.02,14.63,15.02,13.59z"/>
	<path d="M6.84,18.95c0-1.03,0-2.03,0-3.06c0.29,0,0.58,0,0.88,0c0,1.01,0,2.02,0,3.06C7.43,18.95,7.15,18.95,6.84,18.95z"/>
</g>      </svg>
    </SvgIcon>
  )
}
